module.exports = __webpack_public_path__ + "img/apple-touch-icon-76x76.a56e38f8.png";